export default __webpack_public_path__ + "static/media/Ben.1fdfc786.svg";